import { combineReducers } from 'redux'
import appDataState from '@store/reducers/app-data-reducers'
import webSocketState from '@store/reducers/websocket-reducers'
import modalState from '@store/slices/modal-slice'
import clientState from '@store/slices/client-slice'

const rootReducer = combineReducers({
  appDataState,
  webSocketState,
  modalState,
  clientState,
})

export default rootReducer
